export default {"src":"/_next/static/media/gethelp.43ebc5f6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};